





export const getLastPath = () => {
    return localStorage.getItem('lastPath');
  }
  
  export const popLastPath = () => {
    var lastPath = localStorage.getItem('lastPath');
    localStorage.removeItem('lastPath');
    return lastPath;
  }
  
  export const setLastPath = (path:string) => {
    localStorage.setItem('lastPath', path);
  }
  
  // 로그인
  export const clearAccessToken = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    //localStorage.removeItem('agreementConfirmed');
    //localStorage.removeItem('privacyPolicyConfirmed');
    localStorage.removeItem('lastPath');
  }


export const setAccessToken = (accessToken:string, refreshToken:string) => {
  //alert(accessToken);
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
}


export const getAccessToken = async() => {
  
    
      var ret = {accessToken:localStorage.getItem('accessToken'), refreshToken:localStorage.getItem('refreshToken')};
      if(!ret.accessToken && !ret.refreshToken){
        if(window.location.pathname !== '/login' && window.location.pathname !== '/'){
          setLastPath(window.location.pathname + window.location.search);
          window.location.href = '/';
        }
      }
      return ret;
  }